export default __webpack_public_path__ + "static/media/pic6.ab6e665a.jpg";